<template>
    <div>
        <h3 class="form-label w-full lg:w-full">{{ title }}</h3>
        <table class="w-full whitespace-nowrap mb-2">
            <thead>
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">STD</th>
                <th class="px-6 pt-6 pb-4">Year of Passing</th>
                <th class="px-6 pt-6 pb-4">Roll No.</th>
                <th class="px-6 pt-6 pb-4">University / Board / College</th>
                <th class="px-6 pt-6 pb-4">Subject(s)</th>
                <th class="px-6 pt-6 pb-4">Percentage/Division</th>
                <th class="px-6 pt-6 pb-4">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(row, index) in rows"
                :key="row.id"
                class="hover:bg-gray-100 focus-within:bg-gray-100"
            >
                <td class="border-t">
                    <input class="form-input"  :disabled="!row.isEditable" :class="{ error: errors[`academic_qualifications.${index}.std`] }"
                           type="text" v-model="row.std" @blur="saveRow(index)"
                    />
                </td>
                <td>
                    <input v-model="row.year_of_passing" class="form-input"
                           :class="{ error: errors[`academic_qualifications.${index}.year_of_passing`] }" type="number"
                           @blur="saveRow(index)"
                    />
                </td>

                <td class="border-t">
                    <input class="form-input" v-model="row.roll_no"
                           :class="{ error: errors[`academic_qualifications.${index}.roll_no`] }"
                           @blur="saveRow(index)"
                    />
                </td>
                <td class="border-t">
                    <input class="form-input" type="text" v-model="row.university"
                           :class="{ error: errors[`academic_qualifications.${index}.university`] }"
                           @blur="saveRow(index)"
                    />
                </td>
                <td class="border-t">
                    <input class="form-input" type="text" v-model="row.subjects"
                           :class="{ error: errors[`academic_qualifications.${index}.subjects`] }"
                           @blur="saveRow(index)"
                    />
                </td>
                <td class="border-t">
                    <input class="form-input" v-model="row.percentage"
                           :class="{ error: errors[`academic_qualifications.${index}.percentage`] }"
                           @blur="saveRow(index)"
                    />
                </td>
                <td class="border-t" v-if="row.isEditable">
                    <button @click="deleteRow(index)" class="btn btn-danger">Delete</button>
                </td>
            </tr>

            <!-- Add Row Button -->
            <tr>
                <td colspan="7" class="text-center">
                    <button @click.prevent="addRow" class="btn btn-success mt-2 mb-2">Add</button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {ref} from 'vue'

export default {
    name: 'AcademicQualifications',
    props: {
        modelValue: {
            type: Array,
            required: true,
            default: () => [], // Empty array by default, can be passed in by parent
        },
        title: {
            type: String,
            default: 'Academic Qualifications',
        },
    },
    data() {
        const defaultRows = [
            {
                id: 1,
                std: '10th',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },
            {
                id: 2,
                std: '12th',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },
            {
                id: 3,
                std: 'Graduation',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },
            {
                id: 4,
                std: 'Post Graduation',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },
            {
                id: 5,
                std: 'B.ED',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },
            {
                id: 6,
                std: 'D.E.LED',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },
            {
                id: 7,
                std: 'BSTC',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },
            {
                id: 8,
                std: 'NTT',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },
            {
                id: 8,
                std: 'Other',
                year_of_passing: null,
                roll_no: null,
                university: null,
                subjects: null,
                percentage: null,
                isEditable: false
            },

        ]
        const resetRowsList = defaultRows
        return {
            defaultRows,
            resetRowsList,
            errors: {},
        }
    },
    computed: {
        rows: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value); // Emit the updated value back to the parent
            }
        }
    },
    created() {
        if (this.modelValue.length === 0) {
            this.rows = this.cloneRows(this.defaultRows); // Initialize with defaultRows if modelValue is empty
        }
    },
    methods: {
        cloneRows(rows) {
            return JSON.parse(JSON.stringify(rows)); // Ensure a deep clone that breaks reference
        },
        resetRows(){
           // this.rows = [...this.defaultRows];
            console.log(this.resetRowsList);
            this.$emit('update:modelValue', this.resetRowsList); // Emit the reset rows to the parent
        },
        saveRow() {
         ////   this.$emit('update:modelValue', [...this.rows]); // Emit the updated rows back to the parent
            this.$emit('update:modelValue', this.rows); // Emit updated rows back to parent

        },
        addRow() {
            const newId = Date.now() // Unique ID based on the timestamp
            this.rows.push({
                id: newId,
                std: '',
                year_of_passing: '',
                roll_no: '',
                university: '',
                subjects: '',
                percentage: '',
                isEditable:true
            })
        },
        deleteRow(index) {
            this.rows.splice(index, 1) // Remove the row at the given index
            this.saveRow();
        },
        validateRows() {
            this.errors = {}
            this.rows.forEach((row, index) => {
                if (!row.std) {
                    this.errors[`academic_qualifications.${index}.std`] = true
                }
                if (!row.year_of_passing) {
                    this.errors[`academic_qualifications.${index}.year_of_passing`] = true
                }
                if (!row.roll_no) {
                    this.errors[`academic_qualifications.${index}.roll_no`] = true
                }
                if (!row.university) {
                    this.errors[`academic_qualifications.${index}.university`] = true
                }
                if (!row.subjects) {
                    this.errors[`academic_qualifications.${index}.subjects`] = true
                }
                if (!row.percentage) {
                    this.errors[`academic_qualifications.${index}.percentage`] = true
                }
            })

            // Return true if there are no errors
            return Object.keys(this.errors).length === 0
        },
    },
}
</script>

<style scoped>
/* Add your scoped styles here */
</style>
